/**
 * Cvetita Herbal - Ingredient Tabs with Swipe Navigation
 * Event-delegation approach (no inline onclick/script needed).
 *
 * HTML contract (data-attributes on elements):
 *   .cvetita-ingredient-tabs           - root wrapper
 *   [data-ing-tab-btn="<panelIdx>"]    - tab pill button
 *   [data-ing-panel="<panelIdx>"]      - tab panel
 *   [data-ing-track="<panelIdx>"]      - flex track with data-cards, data-current
 *   [data-ing-prev="<panelIdx>"]       - prev arrow
 *   [data-ing-next="<panelIdx>"]       - next arrow
 *   [data-ing-dot="<panelIdx>-<card>"] - dot indicator
 *   [data-ing-counter="<panelIdx>"]    - counter text
 */
(function () {
  "use strict";

  // ── Helpers ──────────────────────────────────────────────────

  function getTrack(panelIdx) {
    return document.querySelector('[data-ing-track="' + panelIdx + '"]');
  }

  function goTo(panelIdx, card) {
    var track = getTrack(panelIdx);
    if (!track) return;
    var total = parseInt(track.getAttribute("data-cards")) || 1;
    card = Math.max(0, Math.min(card, total - 1));
    track.setAttribute("data-current", card);
    track.style.transform = "translateX(-" + card * 100 + "%)";
    updateDots(panelIdx, card, total);
    updateArrows(panelIdx, card, total);
  }

  function updateDots(panelIdx, activeIdx, total) {
    for (var j = 0; j < total; j++) {
      var dot = document.querySelector(
        '[data-ing-dot="' + panelIdx + "-" + j + '"]'
      );
      if (dot) {
        dot.style.width = j === activeIdx ? "20px" : "8px";
        dot.style.background =
          j === activeIdx ? "#82ba32" : "rgba(130,186,50,0.25)";
      }
    }
    var ctr = document.querySelector(
      '[data-ing-counter="' + panelIdx + '"]'
    );
    if (ctr) ctr.textContent = activeIdx + 1 + " / " + total;
  }

  function updateArrows(panelIdx, cur, total) {
    var prev = document.querySelector('[data-ing-prev="' + panelIdx + '"]');
    var next = document.querySelector('[data-ing-next="' + panelIdx + '"]');
    if (prev) {
      prev.style.opacity = cur <= 0 ? "0.3" : "1";
      prev.style.pointerEvents = cur <= 0 ? "none" : "auto";
    }
    if (next) {
      next.style.opacity = cur >= total - 1 ? "0.3" : "1";
      next.style.pointerEvents = cur >= total - 1 ? "none" : "auto";
    }
  }

  // ── Tab switching ───────────────────────────────────────────

  function switchTab(panelIdx) {
    var root = document.querySelector(".cvetita-ingredient-tabs");
    if (!root) return;
    // Find all tab buttons and panels
    var btns = root.querySelectorAll("[data-ing-tab-btn]");
    var panels = root.querySelectorAll("[data-ing-panel]");

    btns.forEach(function (b) {
      var idx = parseInt(b.getAttribute("data-ing-tab-btn"));
      var isActive = idx === panelIdx;
      b.style.background = isActive ? "#82ba32" : "#ffffff";
      b.style.color = isActive ? "#ffffff" : "#555";
      b.style.fontWeight = isActive ? "700" : "600";
      b.style.border = isActive
        ? "2px solid #82ba32"
        : "2px solid #d4d4d4";
      b.style.boxShadow = isActive
        ? "0 4px 14px rgba(130,186,50,0.35)"
        : "0 2px 6px rgba(0,0,0,0.04)";
    });

    panels.forEach(function (p) {
      var idx = parseInt(p.getAttribute("data-ing-panel"));
      p.style.display = idx === panelIdx ? "block" : "none";
    });

    goTo(panelIdx, 0);
  }

  // ── Click delegation ────────────────────────────────────────

  function handleClick(e) {
    var el = e.target;
    // Walk up to 5 levels to find data attribute
    for (var i = 0; i < 5; i++) {
      if (!el || el === document) return;

      // Tab button click
      if (el.hasAttribute("data-ing-tab-btn")) {
        switchTab(parseInt(el.getAttribute("data-ing-tab-btn")));
        return;
      }
      // Prev arrow
      if (el.hasAttribute("data-ing-prev")) {
        var pi = parseInt(el.getAttribute("data-ing-prev"));
        var track = getTrack(pi);
        if (track) {
          var cur = parseInt(track.getAttribute("data-current")) || 0;
          goTo(pi, cur - 1);
        }
        return;
      }
      // Next arrow
      if (el.hasAttribute("data-ing-next")) {
        var ni = parseInt(el.getAttribute("data-ing-next"));
        var track2 = getTrack(ni);
        if (track2) {
          var cur2 = parseInt(track2.getAttribute("data-current")) || 0;
          goTo(ni, cur2 + 1);
        }
        return;
      }
      // Dot click
      if (el.hasAttribute("data-ing-dot")) {
        var parts = el.getAttribute("data-ing-dot").split("-");
        if (parts.length === 2) {
          goTo(parseInt(parts[0]), parseInt(parts[1]));
        }
        return;
      }

      el = el.parentElement;
    }
  }

  // ── Touch / swipe ──────────────────────────────────────────

  function attachTouch(track) {
    var panelIdx = parseInt(track.getAttribute("data-ing-track"));
    var startX = 0,
      diffX = 0,
      isH = null;

    track.addEventListener(
      "touchstart",
      function (e) {
        startX = e.touches[0].clientX;
        diffX = 0;
        isH = null;
        track.style.transition = "none";
      },
      { passive: true }
    );

    track.addEventListener(
      "touchmove",
      function (e) {
        var dx = e.touches[0].clientX - startX;
        if (isH === null) isH = Math.abs(dx) > 8;
        if (!isH) return;
        diffX = dx;
        var cur = parseInt(track.getAttribute("data-current")) || 0;
        var pct =
          -(cur * 100) + (diffX / track.parentElement.offsetWidth) * 100;
        track.style.transform = "translateX(" + pct + "%)";
      },
      { passive: true }
    );

    track.addEventListener("touchend", function () {
      track.style.transition =
        "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)";
      var cur = parseInt(track.getAttribute("data-current")) || 0;
      var total = parseInt(track.getAttribute("data-cards")) || 1;
      var threshold = 50;
      if (diffX < -threshold && cur < total - 1) goTo(panelIdx, cur + 1);
      else if (diffX > threshold && cur > 0) goTo(panelIdx, cur - 1);
      else goTo(panelIdx, cur);
    });
  }

  // ── Init ────────────────────────────────────────────────────

  function init() {
    var root = document.querySelector(".cvetita-ingredient-tabs");
    if (!root) return;

    // Delegate all clicks
    root.addEventListener("click", handleClick);

    // Attach touch swipe to all tracks
    var tracks = root.querySelectorAll("[data-ing-track]");
    tracks.forEach(function (track) {
      attachTouch(track);
      // Initialize arrows for first card
      var panelIdx = parseInt(track.getAttribute("data-ing-track"));
      var total = parseInt(track.getAttribute("data-cards")) || 1;
      updateArrows(panelIdx, 0, total);
    });
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
